
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { BiWrench } from 'react-icons/bi';
import { GiAncientScrew } from 'react-icons/gi';
import { GiStoneWheel } from 'react-icons/gi';
import { GiBlacksmith } from 'react-icons/gi';
import { getFunctions, httpsCallable } from "firebase/functions";
import { loadStripe } from '@stripe/stripe-js';
import { ref as AddOfferRef, set } from "firebase/database";
import dataBase from '../../../config';
import './showChosingOption.css';
import { useAtom } from 'jotai';
import { useLoggedUser, useStepper, useChoosedOption, useShowPopUpModal, useModalVersion, useModalInfo } from '../../../data/GlobalStates';
import LoadingAnimation from '../../LoadingAnimation/LoadingAnimation';


const ShowChosingOption = ({authedUser, OfferTypes, checkUser, setCheckUser}) => { // Wybór rodzaju ogłoszenia


    const history = useHistory(); 
    const stripePromise = loadStripe(process.env.REACT_APP_PUBLISHSTRIPE);
    const db = dataBase; // zapis
    const dbRef = AddOfferRef(dataBase);// DO ODCZYTU

        const date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDay();    

    const prodPriceTest = process.env.REACT_APP_PRODPRICELOWTEST;
    
    //stany globalne:
    const [ LoggedUser, setLoggedUser ] = useAtom(useLoggedUser);
    const [ Stepper, setStepper ] = useAtom(useStepper);
    const [ ChoosedOption, setChoosedOption] = useAtom(useChoosedOption);
    const [ ShowPopUpModal, setShowPopUpModal] = useAtom(useShowPopUpModal);
    const [ ModalVersion, setModalVersion] = useAtom(useModalVersion);
    const [ ModalInfo, setModalInfo] = useAtom(useModalInfo);

    //stany lokalne:
    const [ showAnimation, setShowAnimation] = useState(0); 

    const Premium1 = process.env.REACT_APP_PREMIUMPACKAGE1; 
    const Premium2 = process.env.REACT_APP_PREMIUMPACKAGE2;
    const Premium3 = process.env.REACT_APP_PREMIUMPACKAGE3;

    const BasicLimitless = process.env.REACT_APP_BASICPACKAGE1; 

    const NewPremium1 = process.env.REACT_APP_NEWPREMIUMPACKAGE1; 
    const NewPremium2 = process.env.REACT_APP_NEWPREMIUMPACKAGE2;
    const NewPremium3 = process.env.REACT_APP_NEWPREMIUMPACKAGE3;

    const PremiumPackage1Price = process.env.REACT_APP_PREMIUMPACKAGE1PRICE;
    const PremiumPackage2Price = process.env.REACT_APP_PREMIUMPACKAGE2PRICE;
    const PremiumPackage3Price = process.env.REACT_APP_PREMIUMPACKAGE3PRICE;

    const LimitlessBasicPrice = process.env.REACT_APP_BASICPACKAGE1PRICE;
    const TestPrice = process.env.REACT_APP_PRODPRICELOWTEST;

    const NewPremiumPackage1Price = process.env.REACT_APP_NEWPREMIUMPACKAGE1PRICE;
    const NewPremiumPackage2Price = process.env.REACT_APP_NEWPREMIUMPACKAGE2PRICE;
    const NewPremiumPackage3Price = process.env.REACT_APP_NEWPREMIUMPACKAGE3PRICE;


    const chooseOption = (option) => {//wybiera rodzaj ogłoszenia z 1 kroku
        if (!LoggedUser && !authedUser.currentUser) {
            history.push('/userPanel')
        } else if ((option === 'basic+' || option === 'premium') && (!LoggedUser.NIP || !LoggedUser.City || !LoggedUser.Street )) {
            window.scrollTo(0, 0)
            setShowPopUpModal(true)
            setModalVersion(2)
            setModalInfo({title: 'Uzupełnij Dane', message: 'Przed dodaniem płatnego ogłoszenia uzupełnij NIP oraz Adres Firmy'})
            history.push('/userPanel')
        } else if (LoggedUser && authedUser.currentUser) {
            setChoosedOption(option)
            setStepper(1)
            setCheckUser(checkUser + 1)
            window.scrollTo(0, 0)
        }
      };

    const CalcutePremiumOffers = () => {
        if (LoggedUser.PremiumOffers === 1) {
         return 'ofertę'
        } else if (LoggedUser.PremiumOffers > 1 && LoggedUser.PremiumOffers < 5 ) {
         return 'oferty'
        } else if ( LoggedUser.PremiumOffers >= 5 ) {
         return 'ofert'
        }
    };


const goToCheckOut = async (PackageName) => {
  try {
    const stripe = await stripePromise;

    // Funkcja do wyboru ceny w zależności od pakietu
    const chooseProperPrice = () => {
      if (PackageName === NewPremium1) return NewPremiumPackage1Price;
      if (PackageName === NewPremium2) return NewPremiumPackage2Price;
      if (PackageName === NewPremium3) return NewPremiumPackage3Price;
      if (PackageName === BasicLimitless) return LimitlessBasicPrice;
      return null;
    };

    const priceId = chooseProperPrice();
    if (!priceId) throw new Error("Nieprawidłowy pakiet");

    // Pobieramy funkcje z poprawnym regionem
    const functions = getFunctions(undefined, 'europe-west1');
    const LoadCheckOutFunction = httpsCallable(functions, 'stripeCheckOutLoad');

    // Wywołanie funkcji callable
    const response = await LoadCheckOutFunction({
      ChoosedPackage: PackageName,
      price: priceId,
      User: LoggedUser.name,
      UserMail: LoggedUser.email,
      successURL: 'https://steeljobs.pl/Podsumowanie2'
    });

   
    if (!response?.data?.id) throw new Error("Brak ID sesji Stripe");

    // Zapis w Firebase
    try {
      const now = Date.now();
      await set(AddOfferRef(db, `users/${LoggedUser.keyName}/LastPackagePaymentIntent`), response.data);
      await set(AddOfferRef(db, `users/${LoggedUser.keyName}/LastPackagePaymentSessionUrl`), response.data.url);
      await set(AddOfferRef(db, `users/${LoggedUser.keyName}/LastPackagePaymentSessionUrlCreationTime`), now);
    } catch (dbError) {
      console.error("Błąd przy zapisie w bazie:", dbError);
      set(AddOfferRef(db, `errors/${year}/${month}/${day}/goToCheckOut`), error.message)
    }

    // Przekierowanie do Stripe Checkout
    const { error } = await stripe.redirectToCheckout({ sessionId: response.data.id });
    if (error) throw error;

  } catch (error) {
    console.error("Błąd w goToCheckOut:", error);
    setShowPopUpModal(true);
    setModalVersion(5);
    setModalInfo({
      title: "Ups, nie można teraz dokonać płatności",
      message: error.message || "Wystąpił nieznany błąd"
    });
  }
};


    const buyOffersPackage = (PackageName, AnimNum) => {
      if (AnimNum === 'Anim1') {
        setShowAnimation(1)
      } else if (AnimNum === 'Anim2') {
        setShowAnimation(2)
      } else if (AnimNum === 'Anim3') {
        setShowAnimation(3)
      } else if  (AnimNum === 'Anim4') {
        setShowAnimation(4)
      }
      goToCheckOut(PackageName)
    };


    const scrollToPackages = () => {
     const scrollAmount = window.innerHeight * 0.9;
      window.scrollBy({
      top: scrollAmount,
      left: 0,
      behavior: 'smooth'
      });
};

   const displayBasicOffersNum = (OffersNum) => {
       if (OffersNum == 2) return  "Możesz dodać jeszcze " + OffersNum + " darmowe oferty"
       else if (OffersNum == 1) return  "Możesz dodać jeszcze " + OffersNum + " darmową ofertę"
       else if (OffersNum == 0) return  "Wykorzystałeś darmowe oferty podstawowe"
   };

   const checkBasicOffersNum = () => {
      if (LoggedUser.UnlimitedBasicOffersPackage == true || LoggedUser.BasicOffers > 0) {
        chooseOption('basic')
      } else scrollToPackages()
   };

const add30Days = (timestampMs) => {
  const days30 = 30 * 24 * 60 * 60 * 1000;
  return new Date(timestampMs + days30); // ← zwracamy Date
};

   // dodaj tu walidacje posiadanego pakietu UnlimitedBasicOffersPackage

    return(
      <div id='AddOfferChooseDiv'>
        <div id='SamplesChooseDiv'>
        <h1 className='OffersTypeSectionHeader'>Pojedyńcze ogłoszenia:</h1>

         <div className='SampleContainer' onClick={() => checkBasicOffersNum()}>
             <div className='AddOfferInfoHeaderContainer'>
                <h2 className='DisplayTypeHeader'>Ogłoszenie Podstawowe</h2>
             </div>
               <div className='OfferTypeInfo'>
                {
                  LoggedUser.UnlimitedBasicOffersPackage == true ? 
                  <>
                    <p>- Posiadasz aktywny pakiet nielimitowanych ofert podstawowych</p>
                    <p>- Ważny do { new Date(add30Days(LoggedUser.UnlimitedBasicOffersPackageAddDate)).toLocaleDateString() }</p>
                    <p>- Dodaj ofertę w ramach pakietu</p>
                  </>
                  :
                  null
                }
                {
                  LoggedUser.UnlimitedBasicOffersPackage == false && LoggedUser.BasicOffers > 0 ?
                  <>
                    <p>- {displayBasicOffersNum(LoggedUser.BasicOffers)} </p>
                    <p>- Jeśli chcesz dodać więcej</p>
                    <p>- Zapraszamy do zakupu pakietu ofert</p>
                    <p>- Nie limitowana ilość</p>
                    <p>- Ważny 30 dni</p>
                  </>
                  :
                  null
                }
                {
                   LoggedUser.UnlimitedBasicOffersPackage == false && LoggedUser.BasicOffers == 0 ? 
                   <>
                   <p>- {displayBasicOffersNum(LoggedUser.BasicOffers)} </p>
                    <p>- Jeśli chcesz dodać kolejną</p>
                    <p>- Zakończ wyświetlanie aktywnych</p>
                    <p>- Lub zakup pakiet nielimitowanych ofert</p>
                    <p>- Ważny 30 dni</p>
                   </>
                   :
                   null
                 }
                  
               </div>
               <div className='IconsContainer'>
                   <BiWrench className='AddOfferIcons'/>
                   <GiAncientScrew className='AddOfferIcons'/>
                   <GiStoneWheel className='AddOfferIcons'/>
                   <GiBlacksmith className='AddOfferIcons'/>
               </div>
          </div>

          {LoggedUser.PremiumOffers > 0 ?
            <div className='SampleContainerPremium' onClick={() => chooseOption('premium')}>
                  <div className='AddOfferInfoHeaderContainer'>
                    <h2 className='DisplayTypeHeader'>Ogłoszenie Premium</h2>
                      </div>
                       <div className='OfferTypeInfo'>
                          <p>W ramach wykupionego pakietu,</p> 
                          <p>Posiadasz <strong>{LoggedUser.PremiumOffers}</strong> {CalcutePremiumOffers()} Premium do wykorzystania</p> 
                          <p>- Czas wyświetlania <strong>{OfferTypes[2].displayTime}</strong> dni </p>
                          <p>- wyświetlanie przed ofertami podstawowymi</p>
                          <p>- <strong>wyróżnienie na liście ogłoszeń</strong></p>
                          <p>- <strong>wyróżnienie ikony oferty na mapie</strong></p>
                       </div>
                       <div className='IconsContainer'>
                           <BiWrench className='AddOfferIcons'/>
                           <GiAncientScrew className='AddOfferIcons'/>
                           <GiStoneWheel className='AddOfferIcons'/>
                           <GiBlacksmith className='AddOfferIcons'/>
                      </div>
            </div>
             :
          <div className='SampleContainerPremium' onClick={scrollToPackages}>
            <div className='AddOfferInfoHeaderContainer'>
                <h2 className='DisplayTypeHeader'>Ogłoszenie Premium</h2>
              </div>
               <div className='OfferTypeInfo'>
                  <p>- <strong>Wyświetlanie przed ofertami podstawowymi</strong></p>
                  <p>- <strong>Wyróżnienie na liście ogłoszeń</strong></p>
                  <p>- <strong>Wyróżnienie ikony oferty na mapie</strong></p>
                  <p>- Możliwość zakupu jedynie w pakietach</p>
                  <p>- Cena jednostkowa zależna jest od wybranego pakietu</p>
                  <p>- Aktualnie nie posiadasz ofert premium</p>
                  <p>- Możesz je kupić poniżej</p>
               </div>
               <div className='IconsContainer'>
                   <BiWrench className='AddOfferIcons'/>
                   <GiAncientScrew className='AddOfferIcons'/>
                   <GiStoneWheel className='AddOfferIcons'/>
                   <GiBlacksmith className='AddOfferIcons'/>
              </div>
          </div>
          }
         </div>
         <div id='SamplesChooseDiv'>
           <h1 className='OffersTypeSectionHeader'>Pakiety ogłoszeń:</h1>
            <p className='ChoosingOptionInfo'>Pakiety aktywowane są automatycznie po zaksięgowaniu płatności.</p>

           <div className='SampleContainer' onClick={() => buyOffersPackage(BasicLimitless, 'Anim4')}>
                { showAnimation === 4 ? <LoadingAnimation classVariant={'choosingOption'}/> : ''}
                 <div className='AddOfferInfoHeaderContainer'>
                  <h2 className='DisplayTypeHeader'>Pakiet nielimitowanych ofert podstawowych</h2>
                 </div>
                 <div className='OfferTypeInfo'>
                   <p>- <strong>50 PLN</strong> PLN + 23% Vat</p>
                   <p>- Nieograniczona ilość ofert</p>
                   <p>- Ważny 30 dni od daty zakupu</p>
                 </div>
               <div className='IconsContainer'>
                   <BiWrench className='AddOfferIcons'/>
                   <GiAncientScrew className='AddOfferIcons'/>
                   <GiStoneWheel className='AddOfferIcons'/>
                   <GiBlacksmith className='AddOfferIcons'/>
               </div>
          </div>

               <div className='SampleContainer' onClick={() => buyOffersPackage(NewPremium1, 'Anim1')}>
                { showAnimation === 1 ? <LoadingAnimation classVariant={'choosingOption'}/> : ''}
                 <div className='AddOfferInfoHeaderContainer'>
                  <h2 className='DisplayTypeHeader'>Pakiet 10 ofert premium</h2>
                 </div>
                 <div className='OfferTypeInfo'>
                   <p>- <strong>{OfferTypes[3].price}</strong> PLN + 23% Vat</p>
                   <p>- cena jednostkowa <strong>{OfferTypes[3].price/10}</strong> PLN + 23% Vat</p>
                   <p>- Nieograniczony czas na wykorzystanie</p>
                 </div>
               <div className='IconsContainer'>
                   <BiWrench className='AddOfferIcons'/>
                   <GiAncientScrew className='AddOfferIcons'/>
                   <GiStoneWheel className='AddOfferIcons'/>
                   <GiBlacksmith className='AddOfferIcons'/>
               </div>
          </div>

          <div className='SampleContainer' onClick={() => buyOffersPackage(NewPremium2, 'Anim2')}>
            { showAnimation === 2 ? <LoadingAnimation classVariant={'choosingOption'}/> : ''}
             <div className='AddOfferInfoHeaderContainer'>
                <h2 className='DisplayTypeHeader'>Pakiet 30 ofert premium</h2>
             </div>
               <div className='OfferTypeInfo'>
                  <p>- <strong>{OfferTypes[4].price}</strong> PLN + 23% Vat</p>
                  <p>- cena jednostkowa <strong>{(OfferTypes[4].price/30).toFixed(2)}</strong> PLN + 23% Vat</p>
                  <p>- Nieograniczony czas na wykorzystanie</p>
               </div>
               <div className='IconsContainer'>
                   <BiWrench className='AddOfferIcons'/>
                   <GiAncientScrew className='AddOfferIcons'/>
                   <GiStoneWheel className='AddOfferIcons'/>
                   <GiBlacksmith className='AddOfferIcons'/>
               </div>
          </div>

          <div className='SampleContainer' onClick={() => buyOffersPackage(NewPremium3, 'Anim3')}>
            { showAnimation === 3 ? <LoadingAnimation classVariant={'choosingOption'}/> : ''}
             <div className='AddOfferInfoHeaderContainer'>
                <h2 className='DisplayTypeHeader'>Pakiet 50 ofert premium</h2>
             </div>
               <div className='OfferTypeInfo'>
                  <p>- <strong>{OfferTypes[5].price}</strong> PLN + 23% Vat</p>
                  <p>- cena jednostkowa <strong>{OfferTypes[5].price/50}</strong> PLN + 23% Vat</p>
                  <p>- Nieograniczony czas na wykorzystanie</p>
               </div>
               <div className='IconsContainer'>
                   <BiWrench className='AddOfferIcons'/>
                   <GiAncientScrew className='AddOfferIcons'/>
                   <GiStoneWheel className='AddOfferIcons'/>
                   <GiBlacksmith className='AddOfferIcons'/>
               </div>
          </div>
         </div>
      </div>
    )
   };


   export default ShowChosingOption;